// extracted by mini-css-extract-plugin
module.exports = {"spacer":"listDrawer_spacer__Cix_M"};